import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Tag, Input, Select, Space, message } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const { Option } = Select;

const STATUS_CORES = {
  rascunho: 'default', enviada: 'blue', aprovada: 'green',
  recusada: 'red', cancelada: 'red', perdida: 'red', faturada: 'gold',
};

const fmt = (v) => 'R$ ' + parseFloat(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const fmtData = (v) => v ? new Date(v).toLocaleDateString('pt-BR') : '-';

export default function PropostasProdutosLista() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');
  const navigate = useNavigate();

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoading(true);
    try {
      const r = await api.get('/propostas-produtos');
      setDados(r.data || []);
    } catch {
      message.error('Erro ao carregar propostas de produto');
    } finally {
      setLoading(false);
    }
  };

  const filtradas = dados.filter(p => {
    const t = busca.toLowerCase();
    const cliente = p.razao_faturamento || p.razao_social || p.nome_cliente || '';
    const bateBusca = !t
      || (p.numero || '').toLowerCase().includes(t)
      || cliente.toLowerCase().includes(t)
      || (p.cnpj_faturamento || '').toLowerCase().includes(t)
      || (p.titulo || '').toLowerCase().includes(t);
    const bateStatus = !filtroStatus || p.status === filtroStatus;
    return bateBusca && bateStatus;
  });

  const statusDisponiveis = Array.from(new Set(dados.map(p => p.status).filter(Boolean)));

  const colunas = [
    { title: 'A\u00e7\u00f5es', width: 70, render: (_, r) => (
      <Button size="small" icon={<EyeOutlined />} onClick={() => navigate('/propostas-produtos/' + r.id)} />
    )},
    { title: 'N\u00famero', dataIndex: 'numero', width: 130, render: v => <Tag color="blue">{v}</Tag> },
    { title: 'Cliente', render: (_, r) => r.razao_faturamento || r.razao_social || r.nome_cliente || '-' },
    { title: 'T\u00edtulo', dataIndex: 'titulo', ellipsis: true, width: 200 },
    { title: 'CNPJ', dataIndex: 'cnpj_faturamento', width: 160 },
    { title: 'Status', dataIndex: 'status', width: 120, render: v => <Tag color={STATUS_CORES[v] || 'default'}>{v || '-'}</Tag> },
    { title: 'Total', dataIndex: 'valor_total', width: 130, render: v => fmt(v) },
    { title: 'Data', dataIndex: 'criado_em', width: 110, render: v => fmtData(v) },
  ];

  return (
    <Card>
      <Space style={{ marginBottom: 12 }} wrap>
        <Input.Search placeholder={"Buscar por n\u00famero, cliente, CNPJ ou t\u00edtulo..."} allowClear onChange={e => setBusca(e.target.value)} onSearch={v => setBusca(v)} style={{ width: 320 }} />
        <Select allowClear placeholder="Filtrar por status" onChange={v => setFiltroStatus(v || '')} style={{ width: 180 }}>
          {statusDisponiveis.map(s => <Option key={s} value={s}>{s}</Option>)}
        </Select>
      </Space>
      <Table columns={colunas} dataSource={filtradas} loading={loading} rowKey="id" locale={{ emptyText: 'Nenhuma proposta de produto ainda.' }} scroll={{ x: 900 }} />
    </Card>
  );
}
